<div *ngIf="statuses?.length" class="status-tracking-graph">
  <div
    *ngFor="let status of statuses; let last = last"
    class="status-tracking-item"
    [ngClass]="status?.acceptanceType | lowercase"
  >
    <ui-svg-icon [name]="sCodeIcons.get(status.statusCode)" class="status-tracking-item__icon"></ui-svg-icon>
    <div
      *ngIf="last && status?.acceptanceType !== acceptanceType.Received && !status?.current"
      class="bubble-last-status"
    ></div>
    <div class="status-info">
      <div class="tw-flex">
        <span class="status-info__code">
          {{ 'publicTracking.statusTracking.statusCodes.' + status.statusCode | translate }}
        </span>
        <ui-tooltip-alert
          *ngIf="status?.latestNotification?.reason"
          [tooltipText]="status?.latestNotification?.reason"
          [iconType]="iconType.AlertWarningFilled"
          [iconSize]="iconSize.Small"
          [iconColor]="iconColor.Yellow"
          class="status-info__icon"
        ></ui-tooltip-alert>
        <ui-tooltip-alert
          *ngIf="status.carrierMessage"
          [tooltipText]="status.carrierMessage"
          [iconType]="iconType.Message"
          [iconSize]="iconSize.Medium"
          [iconColor]="iconColor.Black"
          class="tw-ml-1"
        ></ui-tooltip-alert>
      </div>
      <span class="status-info__title">{{ status?.title }}</span>
      <span class="status-info__address">{{ status?.address }}</span>
      <span class="status-info__date">
        <span
          *ngIf="status?.acceptanceType === acceptanceType.NotReceived && status?.assignedArrivalTime"
          class="status-info__expected-at"
        >
          {{ ('load.status.expectedAt' | translate) + ': ' }}
        </span>
        <ui-date-with-timezone
          *ngIf="isTimezoneAvailable; else timezoneNotAvailable"
          [localDate]="status?.assignedArrivalTime"
          class="cropped"
        ></ui-date-with-timezone>
        <ng-template #timezoneNotAvailable>
          {{
            status?.acceptanceType === acceptanceType.NotReceived && status?.assignedArrivalTime
              ? (status?.assignedArrivalTime | date : shortDateFormat)
              : (status?.assignedArrivalTime | date : dateFormat)
          }}
        </ng-template>
      </span>
    </div>
  </div>
</div>
